// src/api/xoe/XoePresenceApi.ts
// The presence heartbeat (ClickUp 14ygtkj83tv S13): `POST /practitioner/xoe/presence` on the
// xoe-agent host (`VITE_XOE_AGENT_SERVER`, already `/api`-suffixed), the `XoeSettingsApi.ts` shape.
// The host is read at call time (the `xoeBaseUrl.ts` rule): the runtime env is injected by nginx.

import { ENV } from "../../config/runtimeEnv";
import type { XoePresencePayload } from "../../types/xoe/XoeTypes";
import { http } from "../../lib/http/client";

const PRESENCE_PATH = "/practitioner/xoe/presence";

/** 204 on success; the caller treats every failure as silent — a heartbeat has no UI. */
export const sendXoePresence = async (payload: XoePresencePayload): Promise<void> => {
	await http.post(`${ENV.VITE_XOE_AGENT_SERVER}${PRESENCE_PATH}`, payload);
};
